import React, { useState, createContext, useEffect } from 'react';
import axios from 'axios';


export const ArticleContext = createContext();


export const ArticleProvider = (props) => {
    const categories = window?.listArticles?.articleCategory;
    const articleIds = Array.isArray(window?.listArticles?.articleIds)
        ? window.listArticles.articleIds.map((id) => parseInt(id, 10)).filter(Boolean)
        : [];
    const [loading, isLoading] = useState(false);
    const [articles, setArticles] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const query = new URLSearchParams({
        _embed: "1",
        per_page: String(articleIds.length ? Math.min(articleIds.length, 100) : 100),
    });

    if (articleIds.length) {
        query.set("include", articleIds.join(","));
        query.set("orderby", "include");
    } else {
        query.set("orderby", "menu_order");
        query.set("order", "asc");

        if (categories !== null && categories !== undefined && categories !== "") {
            const categoryValue = Array.isArray(categories) ? categories.join(",") : categories;
            query.set("categories", categoryValue);
        }
    }

    const URL = `/wp-json/wp/v2/posts?${query.toString()}`;

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                isLoading(true)
                const { data } = await axios.get(URL);
                setArticles(data)
                setSearchResults(data)
            } catch (error) {
                console.log(error)
            }
            finally {
                isLoading(false)
            }
        };

        fetchArticles();
    }, [URL])


    return (
        <ArticleContext.Provider value={{
            articles: [articles, setArticles],
            searchTerm: [searchTerm, setSearchTerm],
            searchResults: [searchResults, setSearchResults],
            loading: [loading, isLoading]
        }}>
            {props.children}
        </ArticleContext.Provider>
    );
}

export default ArticleContext;
